import { Injectable } from "@angular/core";
import { ApiBaseService } from "./api-base.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { ConfigService } from "../../shared/services/config.service";
import { UserService } from "../../shared/services/user.service";

@Injectable({
  providedIn: "root"
})
export class TimeTypesService extends ApiBaseService {
  constructor(private configService: ConfigService, private http: HttpClient, private us: UserService) {
    super(us);
    this.httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", APIKEY: "ams-direct-api-admin-key", SessionId: this.userService.sessionId }) };
    this.baseUrl = `${this.configService.config.adminUrl}/api/timetype`;
  }

  getActive(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/getactive`, this.httpOptions);
  }

  

}
